import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { IntlProvider } from 'react-intl'
import { SnackbarProvider } from 'notistack'
import { Provider } from 'jotai'
import BugSnackbar from '@components/BugSnackbar'
import { useQueryPersistence } from '../hooks/useQueryPersistence'
import { useOfflineQueueManager } from '../hooks/useOfflineQueueManager'

import ThemeProvider from './ThemeProvider'
import Router from './Router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60, // 1 hours (kept only as offline fallback)
      retry: false,
      // Always rely on fresh data when online; offline shows cached data and
      // auto-refetches on reconnect (default networkMode: 'online')
      staleTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true
    }
  }
})

function AppWithPersistence() {
  useQueryPersistence()
  useOfflineQueueManager()
  return <Router />
}

function App() {
  return (
    <Provider>
      <IntlProvider defaultLocale='pl' messages={{}} locale='pl'>
        <ThemeProvider>
          <SnackbarProvider
            anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
            Components={
              {
                bug: BugSnackbar
              } as any
            }
          >
            <QueryClientProvider client={queryClient}>
              <AppWithPersistence />
            </QueryClientProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </IntlProvider>
    </Provider>
  )
}

export default App
